import type { FooterBlockTextType } from '../types';

export const BlockText = ({ data }: { data: FooterBlockTextType }) => (
  <div
    className="_c_cms_footertext _c_cms_footerlist"
    key={`block-text-${data.id}`}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: data.field_html_editor }}
  />
);
